import React, { useEffect, useState } from 'react';
import Alpha, { AlphaProps } from '../color-alpha';
import { color as handleColor, hslaToHsva, HsvaColor, hsvaToHex, hsvaToHsla, RgbaColor } from '../utils/color-convert';

export interface HueProps extends Omit<AlphaProps, 'onChange'> {
    onChange?: ({ value }: { value: number }) => void;
    value: number;
    type: string;
    maxValue: number;
    ratio: number;
}

const HueV2 = React.forwardRef<HTMLDivElement, HueProps>((props, ref) => {
    const {
        prefixCls = 'c-color-hue',
        className,
        onChange,
        direction = 'horizontal',
        hsva,
        value,
        type,
        maxValue,
        ratio = 1,
        ...other
    } = props;
    const [colorStr, setColorStr] = useState('');
    useEffect(() => {
        // const hsla = hsva; //hsvaToHsla(hsva);
        const arr = [-0.5, -0.34, -0.16, 0, 0.16, 0.34, 0.5].map((v) => {
            const max = maxValue * ratio;
            let result = v * max + hsva[type];
            result = result > max ? result - max : result < 0 ? result + max : result;
            const hex = hsvaToHex({ ...hsva, ...{ [type]: result } });
            return hex;
        });
        setColorStr(
            `${arr[0]} 0%, ${arr[1]} 26.04%, ${arr[2]} 45.83%, ${arr[3]} 54.69%, ${arr[4]} 72.92%, ${arr[5]} 85.42%, ${arr[6]} 100%`,
        );
    }, [hsva]);
    return (
        <Alpha
            ref={ref}
            className={`${prefixCls} ${className || ''}`}
            {...other}
            direction={direction}
            background={`linear-gradient(to right, ${colorStr}`}
            hsva={{ h: value, s: 100, v: 100, a: value / maxValue }}
            onChange={(_, interaction) => {
                onChange &&
                    onChange({
                        value: maxValue * interaction.left,
                    });
            }}
        />
    );
});

HueV2.displayName = 'HueV2';

export default HueV2;
